import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { demo } from 'page/catalog/store/CatalogStore'
import { user } from 'page/catalog/store/UserStore'
import { userModal, UserModalStore } from 'page/catalog/UserModal/store/UserModalStore'
import { formatPhone } from 'util/phone'
import { emdash } from 'util/typo'

export const UserButton = observer(() => {
  return user.present ? <Regular /> : <Empty />
})

const Empty = observer(() => {
  const { data } = useDemo()
  const disabled = !employee.user

  const onClick = useLatestCallback(() => {
    userModal.open(new UserModalStore(data))
  })

  return <Button pad={[0, 12]} large primary
    action={onClick} disabled={disabled}>
    {i18n('FindCustomer')}
  </Button>
})

const Regular = observer(() => {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const { data } = useDemo()
  const { name, phone, email, card, picture } = user.it.data
  const info = be ? email : bc ? card : formatPhone(phone)

  const onClick = useLatestCallback(() => {
    userModal.open(new UserModalStore(data, user.it.data))
  })

  return <Button pad={[0, 8]} large left action={onClick}>
    <Space gap={8} oh>
      <Circle image={picture} icon="person" />
      <Vertical gap={4} oh>
        <Typo size={11} one upper medium secondary={!name}>
          {name || emdash}
        </Typo>
        <Typo size={11} one secondary ellipsis>
          {info || emdash}
        </Typo>
      </Vertical>
    </Space>
  </Button>
})
